import { GridCellParams } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';
import { v4 } from 'uuid';
import { Icon } from '../../../Atoms/Icon';
import { addDrawer, DrawerState, updateDrawerOpenSubject } from '../../../../store/Drawer';
import { getRpmAccountById } from '../../../../store/RpmAccount';
import { getMetaData, ComponentName } from '../../DetailsDrawer/detailsDrawersHelpers';
import { getProvisionalAssetById } from '../../../../store/ProvisionalAsset';
import { getAssetById } from '../../../../store/Asset';

export type DetailCTARendererProps = {
  data: GridCellParams;
  value: string;
  valueFormatted: string;
  onClick?: () => void;
  state: DrawerState;
};

export const handleAssetClick = async (assetId: string, type: ComponentName) => {
  const asset = type === ComponentName.ASSET ? await getAssetById(assetId) : await getProvisionalAssetById(assetId);
  const assetSfId = 'sf_id' in asset ? asset.sf_id : undefined;
  return addDrawer({
    id: v4(),
    data: asset,
    ...getMetaData({
      name: type,
      sfId: assetSfId,
      id: asset.id,
      data: asset
    })
  });
};

export function DetailCTARenderer({ data, value, valueFormatted, onClick, state }: DetailCTARendererProps) {
  const handleDetailClick = async () => {
    if (state.type) {
      if (state.type === 'rpmAccount') {
        const rpmAccount = await getRpmAccountById(data.row.rpmAccountId);
        addDrawer({
          ...state,
          data: rpmAccount
        });
      } else if (state.type === 'asset') {
        addDrawer({
          ...state
        });
      } else if (state.type === 'provisionalAsset') {
        addDrawer({
          ...state
        });
      }
    } else {
      addDrawer(state);
    }
    updateDrawerOpenSubject(true);
    if (onClick) onClick();
  };

  if (value) {
    return (
      <button
        className="text-indigo"
        data-testid="detail-cta-button"
        onClick={handleDetailClick}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center'
        }}>
        {value}
      </button>
    );
  } else {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%',
          ':hover': {
            cursor: 'pointer'
          }
        }}>
        <Icon
          className="p-3"
          data-testid="detail-cta-icon"
          onClick={handleDetailClick}
          type="details"
        />
      </Box>
    );
  }
}
